import { MAP__serializable } from '@shared/dto/_base/MAP__serializable';
import { DTO__generation_tool } from '@shared/dto/generation/DTO__generation_tool';
import { ENUM__image_asset_category } from '../../_fields/ENUM__image_asset_category';
import { GENERATION_TOOL__general__image_aspect_ratio } from '../general/GENERATION_TOOL__general__image_aspect_ratio';
import { GENERATION_TOOL__vision__canny } from './GENERATION_TOOL__vision__canny';
import { GENERATION_TOOL__vision__canny_auto } from './GENERATION_TOOL__vision__canny_auto';
import { GENERATION_TOOL__vision__canny_semi_auto } from './GENERATION_TOOL__vision__canny_semi_auto';

export function FN_GENERATION_TOOL__create_map__line__canny() {
  /*
   *
   */

  /*
   *
   */

  let out = new MAP__serializable<string, DTO__generation_tool>();

  DTO__generation_tool.CREATE_TO_MAP(out, () => GENERATION_TOOL__general__image_aspect_ratio(ENUM__image_asset_category.LINE__CANNY));
  DTO__generation_tool.CREATE_TO_MAP(out, GENERATION_TOOL__vision__canny);
  DTO__generation_tool.CREATE_TO_MAP(out, GENERATION_TOOL__vision__canny_semi_auto);
  DTO__generation_tool.CREATE_TO_MAP(out, GENERATION_TOOL__vision__canny_auto);

  return out;
}
